import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/dashboard/Dashboard')
const Companies = () => import('@/views/administration/companies/Companies')
const Tariffs = () => import('@/views/administration/tariffs/Tariffs')
const BalanceLog = () => import('@/views/administration/balanceLogs/BalanceLogs')
const Users = () => import('@/views/administration/users/Users')
const User = () => import('@/views/administration/users/User')
const Logs = () => import('@/views/administration/logs/Logs')
const PaperActs = () => import('@/views/apk/paperActs/PaperActs')
const Plombs = () => import('@/views/apk/plombs/Plombs')
const Licenses = () => import('@/views/administration/licenses/Licenses')
const License = () => import('@/views/administration/licenses/License')
const SprAddress = () => import('@/views/sprs/addresses/SprAddresses')
const Tasks = () => import('@/views/tasks/tasklist/Tasks')
const Task = () => import('@/views/tasks/tasklist/Task')
const PriceGuide = () => import('@/views/tasks/priceguide/PriceGuide')
const Acts = () => import('@/views/tasks/acts/Acts')
const VerificationProtocols = () => import('@/views/tasks/verification-protocols/VerificationProtocols')
const ActReestrs = () => import('@/views/tasks/reestr/Reestrs')
const ActReestr = () => import('@/views/tasks/reestr/Reestr')
const Act = () => import('@/views/tasks/acts/Act')
const HtmlEditor = () => import('@/views/reports/HtmlEditor')
const UserTasks = () => import('@/views/tasks/usertasks/UserTasks')
const UserTask = () => import('@/views/tasks/usertasks/UserTask')
const MeterTypes = () => import('@/views/sprs/meterTypes/MeterTypes')
const TransportTypes = () => import('@/views/sprs/transportTypes/TransportTypes')
const Reports = () => import('@/views/reports/Reports')
//const ReportDesigner = () => import('@/views/reports/Designer')
const ReportViewer = () => import('@/views/reports/Viewer')
const Projects = () => import('@/views/projects/Projects')
const Project = () => import('@/views/projects/Project')
const UserMapLayer = () => import('@/views/projects/features/user-map-layer/UserMapLayer')
const CommunicationControl = () => import('@/views/projects/features/communication-control/CommunicationControl')
const PressureControl = () => import('@/views/projects/features/pressure-control/PressureControl')
const ConsumptionControl = () => import('@/views/projects/features/consumption-control/ConsumptionControl')
const ConsolidatedBalance = () => import('@/views/projects/features/consolidated-balance/ConsolidatedBalance')
const ExportProviders = () => import('@/views/projects/features/export/ExportProviders')
const ExportProvider = () => import('@/views/projects/features/export/ExportProvider')
const AnalyticsMeters = () => import('@/views/analytics/meters/AnalyticsMeters')
const AnalyticsTransports = () => import('@/views/analytics/transports/AnalyticsTransports')
const Nodes = () => import('@/views/nodes/Nodes')
const Node = () => import('@/views/nodes/Node')
const Meters = () => import('@/views/meters/Meters')
const Meter = () => import('@/views/meters/Meter')
const Transports = () => import('@/views/transports/Transports')
const SimCards = () => import('@/views/sim-cards/SimCards')
const Gateways = () => import('@/views/gateways/Gateways')
const Archive = () => import('@/views/archive/Archive')
const Transport = () => import('@/views/transports/Transport')
const SimCard = () => import('@/views/sim-cards/SimCard')
const Gateway = () => import('@/views/gateways/Gateway')
const LoginView = () => import('../views/account/Login')
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
import {TokenService} from '@/services/account/storage.service'
import Reestr from '../views/tasks/reestr/Reestrs.vue'

Vue.use(Router)

let getPathByUser = () => {
  if (TokenService.getToken() && TokenService.isSimpleUser()) {
    console.log('nodes')
    return '/nodes'
  }

  console.log('dashboard')
  return '/dashboard'
}

const router = new Router({
  mode: 'hash',
  //mode: 'history',
  //history: 'true',
  linkActiveClass: 'open active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }, 
  
  routes: [
    {
      path: '/',
      redirect: getPathByUser(),
      //name: 'Домой',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Статистика',
          component: Dashboard
        },
        {
          path: 'administration',
          name: 'Администрирование',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'companies',
              name: 'Компании',
              component: Companies
            },
            {
              path: 'users',
              name: 'Пользователи',
              component: Users
            },
            {
              path: 'user/:idUser',
              name: 'Пользователь',
              component: User,
              props: true
            },
            {
              path: 'logs',
              name: 'Журналирование',
              component: Logs
            },
            {
              path: 'tariffs',
              name: 'Тарифы',
              component: Tariffs,
            },
            {
              path: 'balance-log',
              name: 'Детализация баланса',
              component: BalanceLog
            },
          ]
        },
        {
          path: 'licensing',
          name: 'Лицензирование',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'licenses-list',
              name: 'Лицензии',
              component: Licenses
            },
            {
              path: '/licenses/:idLicense',
              name: 'Лицензия',
              component: License,
              props: true
            },
            {
              path: 'paper-acts-list',
              name: 'Бумажные акты',
              component: PaperActs
            },            
            {
              path: 'plombs-list',
              name: 'Пломбы',
              component: Plombs
            },            
          ]
        },
        {
          path: 'sprs',
          name: 'Справочники',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'address',
              name: 'Адреса',
              component: SprAddress
            },
            {
              path: 'meterTypes',
              name: 'Типы приборов учета',
              component: MeterTypes
            },
            {
              path: 'transportTypes',
              name: 'Типы устройств связи',
              component: TransportTypes
            },
          ]
        },
        {
          path: 'tasks-list',
          name: 'Задания',
          component: Tasks,
        },        
        {
          path: '/task/:idTask',
          name: 'Задание',
          component: Task,
          props: true
        },
        {
          path: 'acts-list',
          name: 'Акты',
          component: Acts,
        },
        {
          path: 'verification-protocols',
          name: 'Протоколы поверок',
          component: VerificationProtocols
        },
        {
          path: '/act/:idTask',
          name: 'Акт',
          component: Act,
          props: true
        },
        {
          path: 'acts-reestr',
          name: 'Реестры',
          component: ActReestrs,
        },
        {
          path: 'price-guide',
          name: 'Справочник цен',
          component: PriceGuide
        },
        {
          path: 'acts-reestr/:idReestr',
          name: 'Реестр использованных актов и пломб',
          component: ActReestr,
          props: true
        },
        {
          path: 'tasks-read-statements',
          name: 'Пользовательские задания',
          component: UserTasks,
        },
        {
          path: '/user-task/:idTask',
          name: 'Пользовательское задание',
          component: UserTask,
          props: true
        },        
        /*{
          path: 'tasks-read-statements',
          name: 'Снятие показаний',
          component: TaskReadStatements,
        },*/
        {
          path: 'reports',
          name: 'Отчеты',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'designer',
              name: 'Редактор',
              component: Reports
            },
            {
              path: 'designer-html',
              name: 'Редактор HTML',
              component: HtmlEditor,
              props: true
            },
            {
              path: 'viewer',
              name: 'Просмотр',
              component: ReportViewer
            },            
          ]
        },
        {
          path: 'projects',
          name: 'Проекты',
          component: Projects,
        },
        {
          path: 'project/:idProject',
          component: Project,
          name: 'Проект',
          props: true
        }, 
        {
          path: 'project/:idProject/communication-control',
          component: CommunicationControl,
          name: 'Контроль связи',
          props: true
        },
        {
          path: 'project/:idProject/user-map-layer',
          component: UserMapLayer,
          name: 'Редактор карты',
          props: true
        },
        {
          path: 'project/:idProject/pressure-control',
          component: PressureControl,
          name: 'Контроль давления',
          props: true
        },
        {
          path: 'project/:idProject/consumption-control',
          component: ConsumptionControl,
          name: 'Контроль расхода',
          props: true
        },
        {
          path: 'project/:idProject/consolidated-balance',
          component: ConsolidatedBalance,
          name: 'Схема водного баланса',
          props: true
        },
        {
          path: 'project/:idProject/export-providers',
          component: ExportProviders,
          name: 'Провайдеры экспорта',
          props: true
        },
        {
          path: 'export-providers/:idExportProvider',
          component: ExportProvider,
          name: 'Провайдер экспорта',
          props: true
        },
        {
          path: 'analytics-meters',
          name: 'Аналитика приборов учета',
          component: AnalyticsMeters,
        },
        {
          path: 'analytics-transports',
          name: 'Аналитика устройств связи',
          component: AnalyticsTransports,
        },
        {
          path: 'nodes',
          name: 'Объекты',
          component: Nodes,
        },
        {
          path: 'node/:idNode',
          component: Node,
          name: 'Объект',
          props: true
        },
        {
          path: 'meters',
          name: 'Приборы учета',
          component: Meters
        },
        {
          path: 'meter/:idMeter',
          name: 'Прибор учета',
          component: Meter,
          props: true
        },
        {
          path: 'transports',
          name: 'Устройства передачи данных',
          component: Transports
        },
        {
          path: 'transport/:idTransport',
          component: Transport,
          name: 'Устройство передачи данных',
          props: true
        },
        {
          path: 'sim-cards',
          name: 'SIM карты',
          component: SimCards
        },
        {
          path: 'sim-cards/:idSimCard',
          component: SimCard,
          name: 'SIM карта',
          props: true
        },
        {
          path: 'gateways',
          name: 'Базовые станции',
          component: Gateways
        },
        {
          path: 'gateways/:idGateway',
          component: Gateway,
          name: 'Базовая станция',
          props: true
        },
        {          
          path: 'archive',
          component: Archive,
          name: 'Архив',
        },
        {
          path: '*/*',
          redirect: {path: 'nodes'}
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true
      }
    },
    {
      path: '*',
      name: 'notFound',
      component: Page404,
    }
  ]
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = TokenService.getToken();

  if (!isPublic && !loggedIn) {
    console.log("not loggedIn", to.fullPath)

    return next({
      path:'/login',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }

  next();
})

export default router
